"use client"

import { useState, useEffect } from 'react'

/**
 * Hook to detect if the current viewport is mobile-sized
 * Uses 768px (md breakpoint) as the threshold
 *
 * @param breakpoint - Custom breakpoint in pixels (default: 768)
 * @returns boolean - true if viewport width is less than breakpoint
 */
export function useIsMobile(breakpoint: number = 768): boolean {
  // Default to false (desktop) to avoid hydration mismatch
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    // Check initial value
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < breakpoint)
    }

    // Set initial value
    checkIsMobile()

    // Listen for resize events with debounce for performance
    let timeoutId: NodeJS.Timeout
    const handleResize = () => {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(checkIsMobile, 100)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
      clearTimeout(timeoutId)
    }
  }, [breakpoint])

  return isMobile
}
